@if (!nextStep) {
<div class="container qai-auth-container d-flex align-items-center justify-content-center">
  <div class="card p-4 shadow">
    <div class="card-body p-5 pt-2 pb-2">
      <h3 class="card-title my-5 text-center fw-bold" i18n>Benvenuto!</h3>
      <form [formGroup]="loginForm" (ngSubmit)="loginWithOTP()">
        <div class="mb-3">
          <fa-icon [icon]="faAt" class="qai-login-icon" style="color: lightgrey"></fa-icon>
          <input type="text" formControlName="username" id="username" name="username"
            class="form-control qai-form-control" placeholder="Email">
        </div>
        <div class="mb-5">
          <app-password-input [control]="loginForm.controls['password']" placeholder="Password" id="password" />
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <app-loading-button [loading]="loading" [disabled]="loginForm.invalid || loading" i18n>
            Login
          </app-loading-button>
        </div>
      </form>
      <div class="text-center pt-2 pb-5">
        <a class="btn btn-link btn-sm" [routerLink]="['/auth/forgot-password']" (click)="loginForm.reset()">
          Password Dimenticata
        </a>
      </div>
      <div class="tim-logo pt-4">
        <img class="mx-3" src="images/TIM ENTERPRISE_Orizz.Pos_RGB.svg" alt="Tim Enterprise Logo">
      </div>
      <p class="pt-4 text-center tas-version-info" i18n>Versione: {{ version }}</p>
    </div>
  </div>
</div>
}
@else if (nextStep === 'OTP_VERIFY' || nextStep === 'CHANGE_PASSWORD') {
<app-otp [email]="loginForm.get('username')?.getRawValue()" [loading]="loading" action="LOGIN"
  (otpValidated)="finalizeLogin()" (otpExpired)="nextStep = null"></app-otp>
} @else if (nextStep === 'OTP_CHANGE_PASSWORD') {
<app-change-password [expiredPassword]="true" (resetOTP)="nextStep = 'CHANGE_PASSWORD'" (passwordChanged)="nextStep = null"></app-change-password>
}